import React from 'react'
import { Form, Input, Button, Row, Col, message } from 'antd';
import { FORGOT_PASSWORD_QUERY } from '../../constants/graphql-query';
import { useLazyQuery } from 'react-apollo';
import { history } from '../../store';

const ForgotPassword = (props) => {
  const { getFieldDecorator } = props.form;

  const [forgotPasswordCallback, useData] = useLazyQuery(FORGOT_PASSWORD_QUERY, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const handleSubmit = e => {
    e.preventDefault();

    props.form.validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }

      message.loading('Please wait..', 0);

      forgotPasswordCallback({
        variables: {
          email: fieldsValue.username
        }
      })
    });
  };

  if (useData && useData.data && useData.data.forgotPassword) {
    if (useData.data.forgotPassword.msg) {
      message.destroy();
      message.success(useData.data.forgotPassword.msg);
      history.push('/login')
    }
  }

  const config = (input) => ({
    rules: [{ required: true, message: `Please Enter ${input}` }, { pattern: /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_\-.]+\.[A-Za-z]+$/, message: 'Please enter valid email address' }],
  });

  return (
    <Row type="flex" justify="center" gutter={[0, 8]} className="reset-container">
      <Col span={8}>
        <Row gutter={[16, 16]}>
          <Col span={18} align="center">
            <h3><strong>Reset Password</strong></h3>
          </Col>
          <Col span={24}>
            <Form layout="inline" onSubmit={handleSubmit}>
              <Row>
                <Col span={16}>
                  <Form.Item label="Email:">
                    {getFieldDecorator('username', config('Email'))(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" block className="primary-dark">Reset Password</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const ResetPasswordForm = Form.create({ name: 'resetpassword_form' })(ForgotPassword);

export default ResetPasswordForm; 